(() => {
  const root = document.querySelector("[data-absen-vx-pdp]");
  if (!root) return;

  const models = JSON.parse(root.querySelector("[data-vx-models]").textContent);
  const details = document.querySelector(".product-details");
  const summary = details?.querySelector("[data-vx-summary]");
  const productSubtitle = details?.querySelector("[data-vx-product-subtitle]");
  const picker = document.querySelector(
    ".product-details variant-picker, variant-picker",
  );
  const nav = root.querySelector(".absen-vx__nav");
  const formatMetric = (metric) => {
    if (metric.key === "pixel_capacity" && Number(metric.value) >= 1000000)
      return `${Number(metric.value) / 1000000}M`;
    const value = String(metric.value);
    if (metric.key === "maximum_loading_resolution") {
      return `${root.dataset.upTo} ${value.split(";")[0].split("@")[0].trim()}`;
    }
    return metric.unit ? `${value} ${metric.unit}` : value;
  };

  const update = (variantId) => {
    if (!variantId) return;
    if (root.dataset.vxCurrentVariant === String(variantId)) return;
    const model = models.find(
      (item) => String(item.variant_id) === String(variantId),
    );
    if (!model) return;
    root.dataset.vxCurrentVariant = String(variantId);
    root.hidden = false;
    if (summary) summary.hidden = false;
    if (productSubtitle) productSubtitle.hidden = false;

    let currentModelButton;
    root.querySelectorAll("[data-vx-model]").forEach((button) => {
      const current = button.dataset.vxModel === model.name;
      button.classList.toggle("is-current", current);
      button.classList.toggle("selected", current);
      button.setAttribute("aria-pressed", String(current));
      if (current) currentModelButton = button;
    });
    const comparisonScroller = currentModelButton?.closest(
      ".absen-vx__table-wrap",
    );
    if (
      comparisonScroller &&
      comparisonScroller.scrollWidth > comparisonScroller.clientWidth
    ) {
      const modelColumn = currentModelButton.closest("th");
      const labelColumn = comparisonScroller.querySelector(
        ".absen-vx__spec-model-row th:first-child",
      );
      comparisonScroller.scrollTo({
        left: modelColumn.offsetLeft - (labelColumn?.offsetWidth || 0),
        behavior: "smooth",
      });
    }
    root.querySelectorAll("[data-vx-value]").forEach((node) => {
      node.textContent = model[node.dataset.vxValue] || "";
    });
    root.querySelectorAll("[data-vx-current]").forEach((node) => {
      node.classList.toggle(
        "is-current",
        node.dataset.vxCurrent === model.name,
      );
    });
    if (!summary) return;

    const quick = summary.querySelector("[data-vx-quick]");
    quick.replaceChildren(
      ...model.metrics.map((metric) => {
        const item = document.createElement("span");
        const value = document.createElement("b");
        const label = document.createElement("small");
        const displayValue = formatMetric(metric);
        item.classList.toggle("is-long", displayValue.length > 22);
        value.textContent = displayValue;
        label.textContent = metric.label;
        item.append(value, label);
        return item;
      }),
    );
    const fitNote = summary.querySelector("[data-vx-fit-note]");
    fitNote.querySelector("[data-vx-fit-title]").textContent =
      model.fit_title || "";
    fitNote.querySelector("[data-vx-fit-copy]").textContent =
      model.fit_copy || "";
    fitNote.querySelector("[data-vx-application]").textContent =
      model.application || "";
    fitNote.hidden = !model.fit_title && !model.fit_copy;
    const configurationNote = summary.querySelector(
      "[data-vx-configuration-note]",
    );
    configurationNote.textContent = model.configuration_note || "";
    configurationNote.hidden = !model.configuration_note;
  };

  root.querySelectorAll("[data-vx-model]").forEach((button) => {
    button.addEventListener("click", () => {
      const option = picker?.querySelector(
        `[data-variant-id="${button.dataset.variantId}"]`,
      );
      if (option instanceof HTMLOptionElement) {
        option.parentElement.value = option.value;
        option.parentElement.dispatchEvent(
          new Event("change", { bubbles: true }),
        );
      } else {
        option?.click();
      }
      update(button.dataset.variantId);
    });
  });

  let selectionGeneration = 0;
  document.addEventListener("shopify:product:select", (event) => {
    if (event.target !== picker) return;
    const generation = ++selectionGeneration;
    const variantId = event.detail?.variantId;
    if (variantId) update(variantId);
    event.promise?.then((result) => {
      if (generation !== selectionGeneration) return;
      const resolvedId = result?.detail?.resource?.id;
      if (resolvedId) update(resolvedId);
    }).catch((error) => { if (error.name !== "AbortError") console.warn("[absen-pdp] Variant update failed:", error); });
  });

  document.addEventListener("change", (event) => {
    const input = event.target;
    if (!picker?.contains(input)) return;
    const option =
      input instanceof HTMLSelectElement
        ? input.options[input.selectedIndex]
        : input;
    const variantId = option?.dataset?.variantId;
    if (variantId) update(variantId);
  });

  root.querySelectorAll("[data-vx-tab]").forEach((button) => {
    button.addEventListener("click", () => {
      root.querySelectorAll("[data-vx-tab]").forEach((item) => {
        const active = item === button;
        item.classList.toggle("active", active);
        item.classList.toggle("is-active", active);
        item.setAttribute("aria-selected", String(active));
      });
      root.querySelectorAll("[data-vx-table]").forEach((table) => {
        table.hidden = table.dataset.vxTable !== button.dataset.vxTab;
      });
    });
  });

  const links = [...root.querySelectorAll('.absen-vx__nav a[href^="#"]')];
  const pageWrapper = document.querySelector(".page-wrapper");
  const desktopScroller = matchMedia("(min-width: 990px)");
  const scrollContainer = () =>
    desktopScroller.matches ? pageWrapper : document.scrollingElement;
  const scrollViewportTop = () =>
    desktopScroller.matches ? pageWrapper.getBoundingClientRect().top : 0;
  const targets = links
    .map((link) => ({
      link,
      section: document.querySelector(link.getAttribute("href")),
    }))
    .filter(({ section }) => section);
  const navOffset = () =>
    (Number.parseFloat(getComputedStyle(nav).top) || 0) + nav.offsetHeight;
  const setActiveLink = (currentLink) => {
    links.forEach((link) => {
      const active = link === currentLink;
      link.classList.toggle("is-active", active);
      if (active) link.setAttribute("aria-current", "location");
      else link.removeAttribute("aria-current");
    });
  };
  const updateActiveLink = () => {
    if (!targets.length) return;
    const scroller = scrollContainer();
    const offset = scrollViewportTop() + navOffset() + 1;
    const current =
      scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1
        ? targets[targets.length - 1]
        : [...targets]
            .reverse()
            .find(({ section }) => section.getBoundingClientRect().top <= offset) ||
          targets[0];
    setActiveLink(current.link);
  };
  const scrollToSection = (section, behavior) => {
    const scroller = scrollContainer();
    scroller.scrollTo({
      top:
        scroller.scrollTop +
        section.getBoundingClientRect().top -
        scrollViewportTop() -
        navOffset(),
      behavior,
    });
  };
  let scrollFrame;
  const requestActiveUpdate = () => {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(() => {
      scrollFrame = null;
      updateActiveLink();
    });
  };

  targets.forEach(({ link, section }) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      setActiveLink(link);
      scrollToSection(
        section,
        matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
      );
      history.replaceState(null, "", link.getAttribute("href"));
    });
  });
  document.addEventListener("scroll", requestActiveUpdate, {
    capture: true,
    passive: true,
  });
  window.addEventListener("resize", requestActiveUpdate);
  window.addEventListener("hashchange", () => {
    const target = targets.find(({ link }) => link.hash === location.hash);
    if (!target) return;
    setActiveLink(target.link);
    scrollToSection(target.section, "auto");
  });

  const initialTarget = targets.find(
    ({ link }) => link.hash === location.hash,
  );
  if (initialTarget) {
    setActiveLink(initialTarget.link);
    const alignInitialTarget = () => {
      document.fonts.ready.then(() => {
        scrollToSection(initialTarget.section, "instant");
        updateActiveLink();
      });
    };
    if (document.readyState === "complete") alignInitialTarget();
    else window.addEventListener("load", alignInitialTarget, { once: true });
  } else {
    updateActiveLink();
  }

  update(root.dataset.vxInitial);
})();
